import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import { getAccessToken } from '@repo/auth';
import { getCurrentUser, getGetCurrentUserQueryKey } from 'ze-sdk';
export const currentUser = createQueryKeys('user', {
    current: (token)=>({
            queryKey: getGetCurrentUserQueryKey(),
            queryFn: async ()=>{
                if (!token) {
                    return void 0;
                }
                const { value } = await getCurrentUser();
                return value !== null && value !== void 0 ? value : void 0;
            },
            enabled: !!token
        })
});
export function useCurrentUser() {
    const token = getAccessToken();
    const { isLoading, data: user, error } = useQuery(currentUser.current(token));
    return {
        user,
        isLoading,
        error
    };
}
